import { gql } from '@apollo/client';

const QUERY_AREE=gql`
query Area {
  clubmate_clubmatearea_clubmatearea {
    archive
    coordinate
    id
    is_alias
    name
  }
}
`

const QUERY_PACKAGE_AREA_LIST=gql`
query packageArea($packageId: bigint!) {
  clubmate_clubmatearea_clubmatearea(where: {clubmatepackage_packagesareas: {clubmatepackage_clubmatepackage: {id: {_eq: $packageId}}}}){
    id
    name
  }
}
`
const DELETE_PACKAGE = gql`
mutation deletePackage($id:ID!) {
 	clubmate{
    deletePackages(id:$id){
      ok
      message
    }
  }
}
`
const UPSERT_PACKAGE = gql`
mutation upsertPackages($input: PackagesMutationInput!) {
  clubmate{
    upsertPackages(input:$input){
      clubMatePackage{
        numberOfEntry
      }
      errors{
        field
      }
    }
  }
}
`
const UPSERT_PACK = gql`
mutation upsertPack ($id:ID, $price: Float, $numberOfEntry: Int, $entryPackage: Boolean!, $durationInMonth: Int, $durationInDays: Int, $name: String! ) {
      clubmate {
        upsertPackages(input: {id:$id, durationInDays: $durationInDays, durationInMonth: $durationInMonth, entryPackage: $entryPackage, numberOfEntry: $numberOfEntry, price: $price, name: $name}) {
          durationInDays
          durationInMonth
          entryPackage
          numberOfEntry
          price
          name
        }
      }
}
`
export { DELETE_PACKAGE, UPSERT_PACKAGE, UPSERT_PACK, QUERY_AREE, QUERY_PACKAGE_AREA_LIST };